import React, { useEffect, useState, useRef } from "react";
import { useLocation, useHistory } from "react-router-dom";
import { Button, Card, Col, Container, Dropdown, DropdownButton, Form, Modal, Row, Spinner, Table, OverlayTrigger, Tooltip } from "react-bootstrap";
import ApiService, { getCalcomBaseUrl } from "../ApiService";
import Snackbar from "@material-ui/core/Snackbar";
import MuiAlert from "@material-ui/lab/Alert";
import moment from 'moment';
import {getLoggedInPersonName, hasAccessToProductAndOrderData, isClinicianRole, isSuperAdminRole} from "../util/authUtil";
import "react-vertical-timeline-component/style.min.css";
import "react-datepicker/dist/react-datepicker.css";
import removeClass from "../util/RemoveCSS";
import { parseAxiosError } from "../util/parserHelper";
import { isEmptyString, validateEmail } from "../util/validator";
import CalcomModal from "./Appointment/Calcom/CalcomModal";
import { AccordionSummary, AccordionDetails, Accordion } from "@material-ui/core";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import ReleaseNotesModal from "./Modal/ReleaseNotesModal";
import SendNotesModal from "./Modal/SendNotesModal";
import { getSingle, getBookingServices } from "../strapi";
import HistoryComponent from "./HistoryComponent";
import CollectPaymentModal from "./Modal/Payment/CollectPaymentModal";
// Disabled due to security configs for document access. Re-enable when secure/presigned doc flow is available.
// import { Worker } from '@react-pdf-viewer/core';
import { convertEpochToDate } from "../util/common";
import { scheduleFollowUp } from "../util/common";
//@ Page Modules
import Header from "./BookingDetails/Header";
import MainBookingDetails from "./BookingDetails/MainBookingDetails";
import SelfCheckinSteps from "./BookingDetails/SelfCheckinSteps";
import OrderSummary from "./BookingDetails/OrderSummary";
import CareSessionDetails from "./BookingDetails/CareSessionDetails";
import CreateKit from "./BookingDetails/CreateKit";
import SelectAndExecute from "./SelectAndExecute";
import CreateChartNotesModal from "./Common/popUpModals/CreateChartNotesModal";
import SingleChart from "./PatientProfileV2/PatientDashboard/ChartingNotes/SingleChart";

//@ Page Modals
import PatientInfoModal from "./BookingDetails/Modals/PatientInfoModal";
// Disabled due to security configs for document access. Re-enable when secure/presigned doc flow is available.
// import PatientIdentityDocsModal from "./BookingDetails/Modals/PatientIdentityDocsModal";
import SendSignupLinkModal from "./BookingDetails/Modals/SendSignupLinkModal";
import SendPaymentLinkModal from "./BookingDetails/Modals/SendPaymentLinkModal";
import CompleteBookingModal from "./BookingDetails/Modals/CompleteBookingModal";
import CompletePaymentModal from "./BookingDetails/Modals/CompletePaymentModal";
// Disabled due to security configs for document access. Re-enable when secure/presigned doc flow is available.
// import VerifyDocsModal from "./BookingDetails/Modals/VerifyDocsModal";
import ProductSectionProductSection from './BookingDetails/ProductSection';
import GenericConfirmationModal from "./BookingDetails/Modals/GenericConfirmationModal";
import MarkNoShowModal from "./Modal/MarkNoShowModal";
import {getTerminalStatusList} from "../util/bookingUtils";
import { DateTime } from "luxon";
import ErxService from "../service/erxService";
import ERXModal from "./Modal/eRx/ERXModal";
import LabOrderRequisition from "./LabOrderForm/LabOrderRequisition";

function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}

const BookingDetails = () => {
  //& STATES AND DATA
  const [isReadOnly, setIsReadOnly] = useState(false);
  const [readOnlyReason, setReadOnlyReason] = useState('');

  const [hasPatientStateLicense, setHasPatientStateLicense] = useState(false);
  const [isRestrictClinicalAccess, setIsRestrictClinicalAccess] = useState(false);
  const [restrictClinicalAccessReason, setRestrictClinicalAccessReason] = useState('');

  const [bookingDetails, setBookingDetails] = useState(null);
  const [errors, setErrors] = useState([]);
  const [loading, setLoading] = useState(true);
  const [snackOpen, setSnackOpen] = useState(false);
  const [snackText, setSnackText] = useState("");
  const [snackSeverity, setSnackSeverity] = useState("");
  const [showPatientInfoUpdateConfirmModal, setShowPatientInfoUpdateConfirmModal] = useState(false);
  const [showIdentityDocsModal, setShowIdentityDocsModal] = useState(false);
  const [showAppntNotesModal, setShowAppntNotesModal] = useState(false);
  const [showClinicalNotesModal, setShowClinicalNotesModal] = useState(false);
  const [calModal, setCalModal] = useState(false);
  const [showMarkNoShowModal, setShowMarkNoShowModal] = useState(false);
  const [showCancelBookingModal, setShowCancelBookingModal] = useState(false);
  const [userTbdOnboardStatus, setUserTbdOnboardStatus] = useState(false);
  const [userTbdOnboardMessage, setUserTbdOnboardMessage] = useState({
    message: "",
    isError: false,
    isWarning: false
  });
  const [priceModal, setPriceModal] = useState(false);
  const [signupModal, setSignupModal] = useState(false);
  const [payModal, setPayModal] = useState(false);
  const [completeBookingModal, setCompleteBookingModal] = useState(false);
  const [completeBookingAndCollectPaymentModal, setCompleteBookingAndCollectPaymentModal] = useState(false);
  const [verifyDocsModal, setVerifyDocsModal] = useState(false);
  const [products, setProducts] = useState();
  const [statusReason, setStatusReason] = useState(null);
  const [patientInfoUpdateReason, setPatientInfoUpdateReason] = useState(null);
  const [reqServices, setReqServices] = useState([]);
  const [orderSummary, setOrderSummary] = useState(null);
  const [isClinician, setIsClinician] = useState(false);
  const [isAtleastStaff, setIsAtleastStaff] = useState(false);
  const [showKitCreateModal, setShowKitCreateModal] = useState(false);
  const [isSuperAdmin, setIsSuperAdmin] = useState(false);
  const [collectPaymentModal, setCollectPaymentModal] = useState(false);
  const [showConfirmPendingBookingModal, setShowConfirmPendingBookingModal] = useState(false);
  const [showChartingNotesModal, setShowChartingNotesModal] = useState(false);
  const [chartNotes, setChartNotes] = useState([]);
  const [isQuestionnaireFormOpen, setIsQuestionnaireFormOpen] = useState(false);

  const [completeBookingData, setCompleteBookingData] = useState({
    durationMins: "",
    appntEnd: "",
    closingNotes: "",
    ackPatientTbdAccCreated: null,
    ackPaymentCollected: null,
    ackPatientSummarySent: null,
    ackTestKitCreated: false
  });
  const [completePaymentData, setCompletePaymentData] = useState({
    refId: "",
    ackPaymentCollected: null,
    paymentMethod: null
  });

  const changeCompletePaymentData = (field, value) => {
    setCompletePaymentData({ ...completePaymentData, [field]: value });
  };
  removeClass();

  const changeBookingData = (field, value) => {
    setCompleteBookingData({ ...completeBookingData, [field]: value });
  };
  const historyRef = useRef(null);
  const clinicalRef = useRef(null);

  const [orderToggle, setOrderToggle] = useState(false);
  const [productToggle, setProductToggle] = useState(false);
  //$ UPDATE: PATIENT DETAILS
  const [patientUpdatedDetails, setPatientUpdatedDetails] = useState();
  const [errSnackData, setErrSnackData] = useState(null);
  const [successSnackData, setSuccessSnackData] = useState(null);
  const [showyErrors, setShowyErrors] = useState();

  const search = useLocation().search;
  const navigate = useHistory();
  const bookingId = new URLSearchParams(search).get("bookingId");

  const [releaseNotesModalOpen, setReleaseNotesModalOpen] = useState(false);
  const [templates, setTemplates] = useState([]);
  const [patientData, setPatientData] = useState(null);
  const [showErxModal, setShowErxModal] = useState(false);
  const [eRxId, setERxId] = useState("");

  //& runs once when the component loads
  useEffect(() => {
    intialLoadingFetchAndSetBookingDetails()
  }, []);

  const intialLoadingFetchAndSetBookingDetails = () => {
    try{
      setLoading(true);
      handleSnackClose();
      isClinicianRole().then(flag => setIsClinician(flag));
      isSuperAdminRole().then(flag => setIsSuperAdmin(flag));
      hasAccessToProductAndOrderData().then(flag => setIsAtleastStaff(flag));
      (async () => {
        await bookingDetailFetcher()
            .then(res => {
              setBookingDetails(res.data);
              if (res?.data?.careStateRegion) {
                getBookingServiceFromCms(res.data.careStateRegion)
              }
              getChartNotesByBookingId();
            })
            .catch(err => setErrSnackData(parseAxiosError(err)));
      })();
    } catch (err) {
      setErrSnackData(parseAxiosError(err));
    } finally {
      setLoading(false);
    }
  }

  const getChartNotesByBookingId = async () => {
    const response = await ApiService.getChartNotesForBooking(bookingId);
    const chartNotes = [...response?.data];
    const sortedChartNotes = chartNotes?.sort((a, b) => b.createdEpoch - a.createdEpoch);
    setChartNotes(sortedChartNotes || []);
  };
  //& runs when booking details changes
  useEffect(() => {
    if (!bookingDetails) return;
    setLoading(true);

    try {
      setIsReadOnly(bookingDetails?.isReadOnly === true);
      setReadOnlyReason(bookingDetails?.readOnlyReason ?? null);
      setHasPatientStateLicense(bookingDetails?.hasPatientStateLicense === true);
      setIsRestrictClinicalAccess(bookingDetails?.hasReadAccessToClinicalData === false);
      setRestrictClinicalAccessReason(bookingDetails?.restrictClinicalDataAccessReason ?? null);
      setUserTbdOnboardStatus(bookingDetails?.isOnboardTbd === true || bookingDetails?.isOnboardTbd === "true");

      //fetch prior order details
      fetchOrderSummary().then(r => r);
    } catch (err) {
      setErrSnackData({
        message: `failed loading message details,cause: ${err?.message}.Please try again with refresh`
      });
    } finally {
      setLoading(false);
    }
  }, [bookingDetails]);

  useEffect(() => {
    if (!bookingDetails) return;
    (async function() {
      await ApiService.getPatientAccountStatus(bookingDetails?.email)
          .then(res => {
            if (!res?.data) {
              setUserTbdOnboardMessage({
                message: "No customer account found.",
                isError: true,
                hasAcc: false
              });
            }
            setPatientData(res?.data);
            const state = res?.data?.state || res?.data?.address?.region;
            const dob = res?.data?.dob;
            if (state && dob) {
              setUserTbdOnboardMessage({
                message: "Patient Profile is complete",
                isWarning: false,
                hasAcc: true
              });
            } else if (state && !dob) {
              setUserTbdOnboardMessage({
                message: "Missing DOB in Patient Account",
                isWarning: true,
                hasAcc: true
              });
            } else if (!state && dob) {
              setUserTbdOnboardMessage({
                message: "Missing State in Patient Account",
                isWarning: true,
                hasAcc: true
              });
            } else if (!state && !dob) {
              setUserTbdOnboardMessage({
                message: "Missing State and DOB in Patient Account",
                isWarning: true,
                hasAcc: true
              });
            }
          })
          .catch(err => {
            setUserTbdOnboardMessage({
              message: "No customer account found.",
              isError: true,
              hasAcc: false
            });
          });
    })().then(r => r);

  }, [bookingDetails]);

  const fetchOrderSummary = async () => {
    (async function() {
      const res = await ApiService.getBookingOrderSummary(bookingId)
          .then(res => {
            setOrderSummary(res?.data);
            setReqServices(res?.data?.plannedProducts || []);
            return true;
          })
          .catch(err => setErrSnackData(parseAxiosError(err)));
    })().then(r => r);
  };

  const orderSummaryTableData = () => {
    if (!orderSummary || Object.keys(orderSummary).length === 0) {
      return { headers: [], rows: [] };
    }
    const {
      grossTotalPaid = "unknown",
      plannedNetTotal = "unknown",
      netTotalPaid = "unknown",
      taxTotalPaid = "unknown",
      netTotalPaidProductOnly = "unknown",
      totalDonated = "unknown",
      netTotalUnpaid = "unknown",
      taxUnPaid = "unknown",
      grossTotalUnpaid = "unknown",
      totalNetExcessPaid = "unknown",
      paymentStatus = "unknown",
      isRequirePayment = "unknown"
    } = orderSummary || {};
    return {
      // headers: ["Gross paid", "Planned total", "Net paid", "Donated", "Net Un-Paid", "Net excess paid", "Payment status", "Require payment"],
      headers: [
        "Net paid",
        "Tax paid",
        "Gross paid(net+tax)",
        "Net Unpaid",
        "Tax Unpaid",
        "Gross Unpaid(net+tax)",
        "Payment status",
        "Require payment?"
      ],
      rows: [
        [
          `$${netTotalPaid}`,
          `$${taxTotalPaid}`,
          `$${grossTotalPaid}`,
          `$${netTotalUnpaid}`,
          `$${taxUnPaid}`,
          `$${grossTotalUnpaid}`,
          paymentStatus,
          isRequirePayment === true ? "YES" : "NO"
        ]
      ]
    };
  };

  const childOrderTableData = childOrder => {
    if (!childOrder || Object.keys(childOrder).length === 0) {
      return { headers: [], rows: [] };
    }
    const headers = ["Order #", "Gross paid", "Net paid", "Net product-only", "Donated", "PaymentStatus"];
    const {
      number = "unknown",
      grossTotalPaid = "unknown",
      netTotalPaidProductOnly = "unknown",
      netTotalPaid = "unknown",
      donated = "unknown",
      paymentStatus = "unknown"
    } = childOrder || {};

    return {
      headers,
      rows: [[`#${number}`, `$${grossTotalPaid}`, `$${netTotalPaid}`, `$${netTotalPaidProductOnly}`, `$${donated}`, paymentStatus]]
    };
  };

  const childOrderProductsTableData = products => {
    if (!products || Object.keys(products).length === 0 || products?.length === 0) {
      return { headers: [], rows: [] };
    }

    const headers = ["Name", "Qty", "Unit Price", "PaymentStatus"];
    const rows = products?.map(prod => {
      const { name = "unknown", qty = "unknown", unitPrice = "unknown", paymentStatus = "unknown" } = prod || {};
      return [name, qty, `$${unitPrice}`, paymentStatus];
    });
    return {
      headers,
      rows
    };
  };

  useEffect(() => {
    if (errSnackData?.message) {
      handleSnackOpen(errSnackData.message, "error");
    }
  }, [errSnackData]);

  useEffect(() => {
    if (successSnackData?.message) {
      handleSnackOpen(successSnackData.message, "success");
    }
  }, [successSnackData]);

  const ensureUserAccessAndIntegrity = (isAllowUpdateAfterTerminalStatus = false, isClinicalStep = false) => {
    if (isReadOnly) {
      setErrSnackData({
        message: `Action not permitted. Reason: ${readOnlyReason}`
      });
      return false;
    }

    if(isClinicalStep === true && isRestrictClinicalAccess === true){
      setErrSnackData({
        message: `Action not permitted. Reason: ${restrictClinicalAccessReason}`
      });
      return false;
    }

    if (!isAllowUpdateAfterTerminalStatus && bookingDetails?.bookingStatus && getTerminalStatusList().indexOf(bookingDetails?.bookingStatus) !== -1) {
      setErrSnackData({
        message: `Action not permitted. Booking reached terminal status: ${bookingDetails.bookingStatus}`
      });
      return false;
    }
    return true;
  };

  const bookingDetailFetcher = async () => {
    return ApiService.getBookingDetails(bookingId);
  };

  const toggleOrders = () => {
    setOrderToggle(!orderToggle);
  };

  const toggleProducts = () => {
    setProductToggle(!productToggle);
  };

  //stores updated patient info
  const storePatientInfoUpdates = (name, value) => {
    if (bookingDetails[name] && bookingDetails[name] === value) {
      return;
    }
    setPatientUpdatedDetails({ ...patientUpdatedDetails, [name]: value });
  };

  const validateFields = () => {
    let errorMsgs = { email: null, phone: null, mobile: null, reason: null };

    if (!patientUpdatedDetails) {
      handleSnackOpen("Nothing to Update", "error");
      setShowPatientInfoUpdateConfirmModal(false);
      return false;
    }

    // check for email and phone validation
    // phone regex to check for 10 digit number like 9876543210
    const phoneRegex = /^[0-9]*$/;
    const mobileRegex = /^[0-9]{10}$/;

    if (!patientInfoUpdateReason) {
      errorMsgs.updateReason = "Please enter a reason for patient info update";
    }

    if (patientUpdatedDetails?.email && !validateEmail(patientUpdatedDetails?.email)) {
      errorMsgs.email = "Please enter a valid email";
    }

    if (patientUpdatedDetails?.phone && !phoneRegex.test(patientUpdatedDetails?.phone)) {
      errorMsgs.phone = "Please enter valid phone number without any special characters";
    }

    if (patientUpdatedDetails?.mobile && !mobileRegex.test(patientUpdatedDetails?.mobile)) {
      errorMsgs.mobile = "Mobile No should be 10 Digits";
    }
    setShowyErrors(errorMsgs);
    if (errorMsgs?.email || errorMsgs?.phone || errorMsgs?.mobile) {
      handleSnackOpen("Please check the errors and try again", "error");
      setShowPatientInfoUpdateConfirmModal(false);
      return false;
    }
    //everything passed, validation pass
    return true;
  };

  const preparePatientInfo = () => {
    return {
      id: bookingId,
      firstName: patientUpdatedDetails?.firstName,
      lastName: patientUpdatedDetails?.lastName,
      dob: patientUpdatedDetails?.dob,
      email: patientUpdatedDetails?.email,
      mobile: patientUpdatedDetails?.mobile,
      phone: patientUpdatedDetails?.phone || bookingDetails?.mobile,
      address1: patientUpdatedDetails?.address1,
      address2: patientUpdatedDetails?.address2,
      city: patientUpdatedDetails?.city,
      state: patientUpdatedDetails?.state,
      zip: patientUpdatedDetails?.zip,
      symptoms: patientUpdatedDetails?.symptoms,
      medications: patientUpdatedDetails?.medications,
      genderAtBirth: patientUpdatedDetails?.genderAtBirth,
      pronoun: patientUpdatedDetails?.pronoun,
      reasonOrComments: patientInfoUpdateReason
    };
  };

  async function updatePatientInfo() {
    if (isEmptyString(patientInfoUpdateReason)) {
      alert("Please enter reason for update");
      return;
    }
    const areFieldsValid = validateFields();
    if (!areFieldsValid) return;
    setLoading(true);
    await ApiService.updatePatientInfo(bookingId, preparePatientInfo())
        .then(res => {
          setBookingDetails(res?.data);
          setPatientUpdatedDetails("");
          setSuccessSnackData({ message: "Patient info updated successfully!" });
        })
        .catch(err => {
          setErrSnackData(parseAxiosError(err));
        })
        .finally(() => {
          setLoading(false);
          setShowPatientInfoUpdateConfirmModal(false);
          setPatientInfoUpdateReason(null);
        });
  }

  //$ UPDATE: UPDATE CLINICAL NOTES
  async function submitClinicalNotesNow(messageText) {
    if (!messageText) {
      alert("Please enter clinical notes");
      return;
    }
    setLoading(true);
    await ApiService.submitClinicalNotes(bookingId, { notes: messageText })
        .then(resp => {
          setSuccessSnackData({ message: "Clinical notes added!" });
          setBookingDetails(resp?.data);
        })
        .catch(err => {
          setErrSnackData(parseAxiosError(err));
        })
        .finally(() => {
          setLoading(false);
        });
  }

  const verifyPatientIdentity = (reviewResult) => {
    if (!reviewResult) {
      return;
    }
    setLoading(true);
    ApiService.verifySelfCheckInIdentity({ bookingId: bookingId, reviewResult: reviewResult })
        .then(resp => {
          setSuccessSnackData({ message: reviewResult === "ACCEPT" ? "Document approved successfully" : "Document rejected successfully" });
          setBookingDetails(resp?.data);
        })
        .catch(err => {
          setErrSnackData(parseAxiosError(err));
        })
        .finally(() => {
          setLoading(false);
        });
  }

  //$ UPDATE: UPDATE NOTES
  async function submitNotesNow(messageText) {
    if (!messageText) {
      alert("Please enter Appointment Notes");
      return;
    }
    setLoading(true);
    await ApiService.submitNotes(bookingId, { notes: messageText })
        .then(resp => {
          setSuccessSnackData({ message: "Appointment notes added!" });
          setBookingDetails(resp?.data);
        })
        .catch(err => {
          setErrSnackData(parseAxiosError(err));
        })
        .finally(() => {
          setLoading(false);
        });
  }

  //$ UPDATE: UPDATE NOTES
  async function sendReportNow(noteType, notes, releaseNote = false) {
    setLoading(true);
    // remove \n from notes
    notes = notes.replace(/(\r\n|\n|\r)/gm, "");

    await ApiService.sendPatientSummary(bookingId, { summary: notes })
        .then(resp => {
          setBookingDetails(resp?.data);
          setSuccessSnackData({
            message: "Summary report sent to patient successfully!"
          });
          // setSummaryReport("");
          //setSendReport(true);
          getChartNotesByBookingId();
        })
        .catch(err => {
          console.log("err", err);
          setErrSnackData(parseAxiosError(err));
        })
        .finally(() => {
          setLoading(false);
        });
  }

  const refreshUserStatus = async () => {
    const buttonId = document.getElementById("refreshIcon");
    buttonId.disabled = true;
    buttonId.style.transform = "rotate(360deg)";
    const boardStatus = await ApiService.onboardStatus(bookingId)
        .then(res => {
          setUserTbdOnboardStatus(res?.data?.isOnboardTbd === "true" || res?.data?.isOnboardTbd === true);
          setSuccessSnackData({ message: "User's TBD sign-up status updated!" });
        })
        .catch(err => {
          setErrSnackData(parseAxiosError(err));
        })
        .finally(() => (buttonId.disabled = true));
    setTimeout(() => {
      buttonId.style.transform = "rotate(0deg)";
    }, 1001);
  };

  const refreshPaymentStatus = async () => {
    // rotate refreshIcon id image 360 degre on click
    const buttonId = document.getElementById("refreshPayIcon");
    const ordButtonId = document.getElementById("refreshOrderIcon");
    buttonId.style.transform = "rotate(360deg)";
    ordButtonId.style.transform = "rotate(360deg)";

    fetchOrderSummary(r => {
      setSuccessSnackData({ message: "Product and Payment Data Updated" });
    }).catch(err => {
      setErrSnackData(parseAxiosError(err));
    });

    setTimeout(() => {
      buttonId.style.transform = "rotate(0deg)";
      ordButtonId.style.transform = "rotate(0deg)";
    }, 1001);
  };

  const sendSignupLink = async () => {
    await ApiService.sendSignUpLinkToCustomer(bookingId)
        .then(res => {
          setSuccessSnackData({ message: "Signup link sent successfully" });
        })
        .catch(err => {
          setErrSnackData(parseAxiosError(err));
        })
        .finally(() => setSignupModal(false));
  };

  const sendPayLink = async () => {
    await ApiService.sendPayLinkToCustomer(bookingId)
        .then(res => {
          setSuccessSnackData({ message: "Payment link sent successfully" });
        })
        .catch(err => {
          setErrSnackData(parseAxiosError(err));
        })
        .finally(() => setPayModal(false));
  };

  const handleSnackOpen = (text, severity) => {
    setSnackSeverity(severity);
    setSnackText(text);
    setSnackOpen(true);
  };

  const handleSnackClose = () => {
    setSnackOpen(false);
  };

  function openPatientInfoUpdateModal() {
    if (!ensureUserAccessAndIntegrity(true, false)){
      return;
    }
    setShowPatientInfoUpdateConfirmModal(true);
  }

  function openIdentityDocsModal() {
    if (!ensureUserAccessAndIntegrity(true, false)){
      return;
    }
    setShowIdentityDocsModal(true);
  }

  function openAppntNotesModal() {
    if (!ensureUserAccessAndIntegrity(true, false)){
      return;
    }
    setShowAppntNotesModal(true);
  }

  function openConfirmPendingBooking() {
    if (!ensureUserAccessAndIntegrity(true, false)){
      return;
    }
    if(!bookingDetails?.bookingStatus?.includes('PENDING')){
      setErrSnackData({message: "Booking is not in pending confirmation status"});
      return;
    }
    setShowConfirmPendingBookingModal(true);
  }

  function openClinicalNotesModal() {
    if (!ensureUserAccessAndIntegrity(true, true)){
      return;
    }
    setShowClinicalNotesModal(true);
  }

  function openSummaryReportModal() {
    if (!ensureUserAccessAndIntegrity(true, true)){
      return;
    }
    if (userTbdOnboardMessage?.isError) {
      handleSnackOpen("Patient Account Not found", "error");
      return;
    }
    setReleaseNotesModalOpen(true);
  }

  function collectPayment() {
    navigate.push({
      pathname: `/Payment`,
      search: `&ref=booking&id=${bookingId}`,
      state: {
        firstName: `${bookingDetails.firstName}`,
        lastName: `${bookingDetails.lastName}`,
        street: bookingDetails.address1,
        apartment: bookingDetails.address2,
        city: bookingDetails.city,
        state: bookingDetails.careStateRegion,
        zipCode: bookingDetails.zip
      }
    });
  }

  const handleConfirmPendingBooking = async (reason) => {
    setLoading(true);
    try {

      const markConfirmedResp = await ApiService.markConfirmed(bookingDetails.id, reason);
      setBookingDetails(markConfirmedResp.data);
      setSuccessSnackData({ message: "Booking marked as Confirmed" });
    } catch (ex) {
      console.error(ex);
      setErrSnackData({
        message: `Failed to mark booking as confirmed. Reason: ${parseAxiosError(ex)?.reason || "unknown"}`
      })
    } finally {
      setShowConfirmPendingBookingModal(false);
      setLoading(false);
    }
  };

  const assignToMe = async bookingId => {
    setLoading(true);
    await ApiService.assignToMe(bookingId)
        .then(resp => {
          setSuccessSnackData({ message: "Booking assigned to you" });
          bookingDetailFetcher()
              .then(res => setBookingDetails(res.data))
              .catch(err => setErrSnackData(parseAxiosError(err)))
              .finally(() => setLoading(false));
        })
        .catch(ex =>
            setErrSnackData({
              message: `Failed to assign booking to you. Reason: ${parseAxiosError(ex)?.reason || "unknown"}`
            })
        )
        .finally(() => setLoading(false));
  };

  async function updateProduct(productData) {
    setLoading(true);
    await ApiService.updateProductInBooking(bookingId, productData)
        .then(resp => {
          setBookingDetails(resp?.data);
          setSuccessSnackData({ message: "Product updated successfully" });
        })
        .catch(err => {
          setErrSnackData(parseAxiosError(err));
        })
        .finally(() => setLoading(false));
  }

  async function deleteProduct(productId) {
    setLoading(true);
    await ApiService.deleteProductInBooking(bookingId, productId)
        .then(resp => {
          setSuccessSnackData({ message: "Product deleted from Booking" });
          setBookingDetails(resp?.data);
        })
        .catch(err => {
          setErrSnackData(parseAxiosError(err));
        })
        .finally(() => setLoading(false));
  }

  async function addNewProduct(data) {
    const body = {
      id: data?.variantId?.[process.env.REACT_APP_TBD_ENV],
      name: data?.title,
      slug: data?.slug,
      variantId: data?.variantId?.[process.env.REACT_APP_TBD_ENV],
      qty: 1,
      unitPrice: data?.price
    };
    setLoading(true);
    const res = await ApiService.addNewProductToBooking(bookingId, body)
        .then(resp => {
          setBookingDetails(resp?.data);
          setSuccessSnackData({ message: "Product added successfully" });
          return true;
        })
        .catch(err => {
          setErrSnackData(parseAxiosError(err));
        })
        .finally(() => setLoading(false));
  }

  const addServiceToArray = async addServ => {
    if (!ensureUserAccessAndIntegrity(true)) return;

    await addNewProduct(addServ).then(r => r);
  };

  async function completeClinicalAppointment() {
    const isInvalid =
        !completeBookingData?.clinicalServiceMins || !completeBookingData?.clinicalServiceNotes || !completeBookingData?.ackPatientSummarySent;
    if (isInvalid) {
      alert("Please fill all the fields ");
      return;
    }

    await ApiService.completeClinicalServiceAppointment(bookingId, completeBookingData)
        .then(res => {
          setBookingDetails(res?.data);
          setCompleteBookingData({
            clinicalServiceMins: "",
            clinicalServiceNotes: "",
            ackPatientSummarySent: null
          });
          getChartNotesByBookingId();          
        })
        .catch(err => {
          setErrSnackData(parseAxiosError(err));
        })
        .finally(() => handleClose());
  }

  async function completeAppointment() {
    const isInvalid =
        !completePaymentData?.totalDurationMins ||
        !completePaymentData?.actualAppntEnd ||
        !completePaymentData?.closingNotes ||
        !completePaymentData?.ackPatientTbdAccCreated ||
        !completePaymentData?.ackPaymentCollected ||
        !completePaymentData?.paymentRefId ||
        !completePaymentData?.paymentMode ||
        !completePaymentData?.paymentAmount;
    if (isInvalid) {
      alert("Please fill all the fields ");
      return;
    }
    console.info("completePaymentData", JSON.stringify(completePaymentData));
    await ApiService.completeAppointment(bookingId, completePaymentData)
        .then(res => {
          setBookingDetails(res?.data);
          setCompletePaymentData({
            totalDurationMins: null,
            actualAppntEnd: null,
            closingNotes: "",
            ackPatientTbdAccCreated: null,
            ackPaymentCollected: null,
            paymentRefId: null,
            paymentMode: null,
            paymentAmount: null
          });
        })
        .catch(err => {
          setErrSnackData(parseAxiosError(err));
        })
        .finally(() => handleClose());
  }

  function renderErrors() {
    return errors.map((k, i) => {
      return (
          <li style={{ color: "red" }} key={k}>
            {k}
          </li>
      );
    });
  }

  const handleClose = () => {
    setShowPatientInfoUpdateConfirmModal(false);
    setShowAppntNotesModal(false);
    setShowClinicalNotesModal(false);
    setCompleteBookingModal(false);
    setSignupModal(false);
    setPayModal(false);
    setCalModal(false);
    setCompleteBookingAndCollectPaymentModal(false);
    setVerifyDocsModal(false);
    setShowIdentityDocsModal(false);
  };

  const changePrice = (index, value, reason, qty) => {
    let newArray = [...reqServices];
    newArray[index].unitPrice = parseFloat(value);
    newArray[index].qty = parseInt(qty);
    newArray[index].reason = reason;
    setReqServices(newArray);
  };

  const deleteService = async (index, prodId) => {
    if (!ensureUserAccessAndIntegrity(true)) return;
    await deleteProduct(prodId).then(r => r);
  };

  const closePriceModal = () => setPriceModal(false);

  const showPriceModal = index => {
    if (!ensureUserAccessAndIntegrity(true, false)){
      return;
    }
    setPriceModal(index);
  };

  //$ Order Test Kit
  const orderTestKit = async prodInfo => {
    if (!prodInfo?.vendor) setErrSnackData({ message: "Select a lab to order kit" });
    setLoading(true);
    await ApiService.orderKitForBooking(bookingId, {
      productId: prodInfo.uniqueId,
      variantId: prodInfo.variantId,
      vendor: prodInfo?.vendor
    })
        .then(resp => setBookingDetails(resp.data))
        .catch(err => setErrSnackData(parseAxiosError(err)))
        .finally(() => setLoading(false));
  };

  const handleKitLabSelection = (service, lab) => {
    const matchIndex = reqServices?.findIndex(rs => service?.uniqueId === rs.uniqueId || service?.variantId === rs.variantId);
    if (matchIndex === -1) {
      setErrSnackData({
        message: "Cannot find a matching product in the booking. Report to tech"
      });
      return;
    }
    const matchProd = reqServices[matchIndex];
    const updatedProd = { ...matchProd, vendor: lab };
    const allOtherProds = reqServices.filter(rs => !(service?.uniqueId === rs.uniqueId || service?.variantId === rs.variantId)) || [];
    allOtherProds.push(updatedProd);
    setReqServices(allOtherProds);
  };

  const sortedHistoryLogs = () => {
    const historyAndSummaryArr = [...(bookingDetails?.appntNotes ?? [])];
    return historyAndSummaryArr?.sort((a, b) => new Date(b.created) - new Date(a.created));
  };

  const isShowPayButton = () => {
    return true
  };

  const orderKitForBookingFunc = async formData => {
    const isSuccess = await ApiService.orderKitForBooking(bookingDetails.id, formData)
        .then(resp => {
          setBookingDetails(resp?.data);
          setSuccessSnackData({ message: "Kit created successfully!" });
          return true;
        })
        .catch(err => {
          setErrSnackData(parseAxiosError(err));
          return false;
        });
    return isSuccess;
  };
  const getCmsData = async () => {
    const content = await getSingle("clinician-portal", {
      populate: {
        negativeTemplates: {
          populate: "*"
        },
        bookingSummary: {
          populate: "*"
        }
      }
    });
    return {
      revalidate: 10,
      data: content
    };
  };
  
  const getBookingServiceFromCms = (stateCode) => {
    getBookingServices(stateCode)
      .then(res => {
        const bookingServices = [];
        if (res?.data?.length > 0) {
          res.data.forEach(service => {
            bookingServices.push(service);
          });
        }
        setBookingServices(bookingServices);
      })
      .catch(err => {
        console.error("Error while fetching booking services", err);
      });;
  };

  const [bookingServices, setBookingServices] = useState([]);

  useEffect(() => {
    getCmsData()
        .then(res => {
          setTemplates(res?.data?.bookingSummary);
        })
        .catch(err => {
          console.error("CMS Data Fetch Error", err);
        });
  }, []);

  //& Booking Actions
  async function cancelBooking() {
    markAsNoShowOrCancelActionHandler(false);
    if (getTerminalStatusList().includes(bookingDetails?.bookingStatus)) {
      handleSnackOpen("Booking already cancelled or completed", "error");
      return;
    }

    const appntStart = new Date(bookingDetails?.appntStart);
    const currentDate = new Date();

    if (appntStart > currentDate) {
      const calcomBaseUrl = bookingDetails?.calcomBaseUrl || getCalcomBaseUrl();
      const actor = await getLoggedInPersonName();
      window.open(
          `${calcomBaseUrl}/booking/${bookingDetails?.calComUniqueId}?cancel=true&metadata[tbdBookId]=${bookingDetails.id}&metadata[actor]=${actor}&metadata[actorType]=CL`,
          "_blank"
      );
    } else if (appntStart < currentDate) {
      setShowCancelBookingModal(true);
    }
  }

  async function handleMarkAsNoShowAction(){
    await markAsNoShowOrCancelActionHandler(true);
  }

  async function handleCancelBookingAction(){
    await markAsNoShowOrCancelActionHandler(false);
  }

  async function markAsNoShowOrCancelActionHandler(isNoShow = false) {
    if(!ensureUserAccessAndIntegrity(false, false)){
      return;
    }

    if (getTerminalStatusList().includes(bookingDetails?.bookingStatus)) {
      handleSnackOpen("Booking already cancelled or completed", "error");
      return;
    }

    const appntStartEpochSec = DateTime.fromISO(bookingDetails?.appntStart).toSeconds();
    const nowEpochSec = DateTime.now().toSeconds();
    const diffSec = appntStartEpochSec - nowEpochSec;

    const isBookingInFuture = diffSec > 40 * 60; // we need 40 mins buffer to cancel a 30 min slot in cal com

    // if appointment is in the past, show modal and dont show calcom
    if(!isBookingInFuture){
      if(isNoShow) {
        setShowMarkNoShowModal(true);
        setShowCancelBookingModal(false);
      } else {
        setShowCancelBookingModal(true);
        setShowMarkNoShowModal(false);
      }
      return;
    }

    // if appointment is in the future, show calcom and dont show modal. Call api to mark as no show 1st
    await (async () => {
      await ApiService.markPreNoShowCancel(bookingDetails.id, "Pre mark No Show", isNoShow);
    })();
    const calcomBaseUrl = bookingDetails?.calcomBaseUrl || getCalcomBaseUrl();
    const actor = await getLoggedInPersonName();
    window.open(
        `${calcomBaseUrl}/booking/${bookingDetails?.calComUniqueId}?metadata[noShow]=YES&metadata[actor]=${actor}&metadata[tbdBookId]=${bookingDetails.id}&metadata[actorType]=CL&cancel=true`,
        "_blank");
  }

  async function handleNoShowModalSubmit(comment) {
    await (async () => {
      await cancelOrNoShowModalSubmitHandler(comment, true);
    })();
  }

  async function handleCancelBookingModalSubmit(comment) {
    await (async () => {
      await cancelOrNoShowModalSubmitHandler(comment, false);
    })();
  }

  async function cancelOrNoShowModalSubmitHandler(comment, isNoShow = false) {
    if (!ensureUserAccessAndIntegrity(false, false)) {
      return;
    }

    if (getTerminalStatusList().includes(bookingDetails?.bookingStatus)) {
      handleSnackOpen("Booking already cancelled or completed", "error");
      return;
    }

    try {
      setLoading(true);
      const res = await ApiService.markPreNoShowCancel(bookingDetails.id, comment, isNoShow);
      setBookingDetails(res?.data);
      const msg = isNoShow ? "Booking marked as No Show" : "Booking cancelled successfully";
      setLoading(false);
      handleSnackOpen(msg, "success");
    } catch (error) {
      const msg = isNoShow ? "Failed to mark booking as No Show" : "Failed to cancel booking";
      console.error("error", error);
      setLoading(false);
      handleSnackOpen(msg, "error");
    } finally {
      setShowMarkNoShowModal(false);
      setShowCancelBookingModal(false);
    }
  }

  async function rescheduleBooking() {
    if(!ensureUserAccessAndIntegrity(false, false)){
      return;
    }
    if (bookingDetails?.bookingStatus === "COMPLETED" || bookingDetails?.bookingStatus === "CANCELLED") {
      handleSnackOpen("Booking already cancelled or completed", "error");
      return;
    }
    const actor = await getLoggedInPersonName();
    const url = `${process.env.REACT_APP_MAIN_STORE_SITE_URL}/booking/choose-slot?id=${bookingDetails.id}&actor=${actor}&actorType=CL`;
    window.open(url, "_blank");
  }

  function completeClinicalService() {
    if(!ensureUserAccessAndIntegrity(true, true)){
      return;
    }
    setCompleteBookingModal(true);
  }

  function enterPaymentInfo() {
    if(!ensureUserAccessAndIntegrity(true, false)){
      return;
    }
    setCompleteBookingAndCollectPaymentModal(true);
  }

  function sendSummaryReport() {
    openSummaryReportModal();
  }
  const hideErxModal = (orderCreated = false) => {
    setShowErxModal(false);
    if (orderCreated) {
      setSnackOpen(true);
      setSnackSeverity("success");
      setSnackText("Prescription Sent!");
    }
  };
  const openDocVerification = () => {
    setVerifyDocsModal(true);
  };

  const rejectDoc = () => {
    verifyPatientIdentity("REJECT");
    handleClose();
  };

  const acceptDoc = () => {
    verifyPatientIdentity("ACCEPT");
    handleClose();
  };

  //@ Loading Screen
  if (loading) {
    return (
        <Row>
          <Spinner animation="border" role="status">
            <span className="sr-only">Loading...</span>
          </Spinner>
        </Row>
    );
  }

  const handleSendPrescription = async patientEmail => {
    try {
      setSnackOpen(true);
      setSnackSeverity("info");
      setSnackText("This may take a few seconds");
      const userDetailRes = await ApiService.getPatientDetailByEmail(patientEmail);
      const userDetail = userDetailRes?.data;

      if (!userDetail) {
        setSnackOpen(true);
        setSnackSeverity("error");
        setSnackText("Patient account not found");
        return;
      }

      const photonHealthErxPatientId = userDetail?.photonHealthErxPatientId;
      if (photonHealthErxPatientId) {
        setShowErxModal(true);
        setERxId(photonHealthErxPatientId);
        return;
      }

      const sexAtBirth = ErxService.determineSexAtBirth(userDetail?.genderAtBirth ?? userDetail?.gender);
      const eRxIdRes = await ErxService.createPatientOnPhoton(userDetail, sexAtBirth);

      if (eRxIdRes?.data?.erxPhotonId?.id) {
        setShowErxModal(true);
        setERxId(eRxIdRes?.data?.erxPhotonId?.id);
        ApiService.updatePhotonERxPatientId(userDetail?.subUUID, eRxIdRes?.data?.erxPhotonId?.id)
          .then(() => {
            console.log("Patient details updated successfully");
          })
          .catch(err => {
            console.error("Error in updating patient details", err);
          });
      }
    } catch (err) {
      console.error("Error in handleSendPrescription:", err);
      setSnackOpen(true);
      setSnackSeverity("error");
      setSnackText(err?.response?.data?.message ?? err?.message);
    }
  };
  const hideQuestionnaireForm = (isSuccess=false, isError=false, message) => {
    setIsQuestionnaireFormOpen(false);
    if(isSuccess){
      setSnackOpen(true);
      setSnackSeverity("success");
      setSnackText(message);
    }
    if(isError){
      setSnackOpen(true);
      setSnackSeverity("error");
      setSnackText(message);
    }

  };


  //& VIEW
  return (
    <Container fluid={"xxl"}>
      {/* //& Modals */}
      {/* //$ Enter Payment Info Modal */}
      <CollectPaymentModal show={collectPaymentModal} onCompletePayment={() => setCollectPaymentModal(false)} orderSummary={orderSummary} />
      {/* //& Render Errors */}
      <Row>
        <Col>{renderErrors()}</Col>
      </Row>

      <CreateChartNotesModal
        show={showChartingNotesModal}
        onHide={() => setShowChartingNotesModal(false)}
        patientDetails={patientData}
        referenceId={bookingId}
        referenceType="BOOKING"
        fetchChartNotes={() => getChartNotesByBookingId()}
      />

      {/* //& Snack Bar */}
      <Snackbar open={snackOpen} autoHideDuration={6000} onClose={handleSnackClose} anchorOrigin={{ vertical: "top", horizontal: "center" }}>
        <Alert onClose={handleSnackClose} severity={snackSeverity}>
          {snackText}
        </Alert>
      </Snackbar>

      {/* //& Header with Clinician Name */}
      <Header
        bookingDetails={bookingDetails}
        assignToMe={assignToMe}
        unPaidAmt={orderSummary?.grossTotalUnpaid}
        isRequirePayment={orderSummary?.isRequirePayment}
        refreshBookingDetails={intialLoadingFetchAndSetBookingDetails}
      />

      <div
        style={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "flex-start",
          alignItems: "flex-start",
        }}
      >
        <div style={{ display: "block", width: "80%", maxWidth: "80%", marginRight: 20 }}>
          {/* //& Patient Booking Details */}
          <MainBookingDetails
            refreshUserStatus={refreshUserStatus}
            userTbdOnboardStatus={userTbdOnboardStatus}
            userTbdOnboardMessage={userTbdOnboardMessage}
            setSignupModal={setSignupModal}
            bookingDetails={bookingDetails}
            patientData={patientData}
            storePatientInfoUpdates={storePatientInfoUpdates}
            isUserReadOnlyMasterFlag={isReadOnly}
            showyErrors={showyErrors}
            openPatientInfoUpdateModal={openPatientInfoUpdateModal}
            openIdentityDocsModal={openIdentityDocsModal}
            openDocVerification={openDocVerification}
          />

          {/* //& Patient Self Checkin Details */}
          <SelfCheckinSteps
            refreshUserStatus={refreshUserStatus}
            userTbdOnboardStatus={userTbdOnboardStatus}
            userTbdOnboardMessage={userTbdOnboardMessage}
            setSignupModal={setSignupModal}
            bookingDetails={bookingDetails}
            patientData={patientData}
            storePatientInfoUpdates={storePatientInfoUpdates}
            isUserReadOnlyMasterFlag={isReadOnly}
            showyErrors={showyErrors}
            openPatientInfoUpdateModal={openPatientInfoUpdateModal}
            openIdentityDocsModal={openIdentityDocsModal}
          />

          {/* //& Product Section */}
          {isAtleastStaff && (
            <ProductSectionProductSection
              refreshPaymentStatus={refreshPaymentStatus}
              addServiceToArray={addServiceToArray}
              reqServices={reqServices}
              priceModal={priceModal}
              showPriceModal={showPriceModal}
              deleteService={deleteService}
              updateProduct={updateProduct}
              changePrice={changePrice}
              closePriceModal={closePriceModal}
              bookingServices={bookingServices}
            />
          )}

          {/* //& Order Summary */}
          {isAtleastStaff && (
            <OrderSummary
              refreshPaymentStatus={refreshPaymentStatus}
              isShowPayButton={isShowPayButton}
              collectPayment={collectPayment}
              setPayModal={setPayModal}
              orderSummary={orderSummary}
              orderSummaryTableData={orderSummaryTableData}
              childOrderTableData={childOrderTableData}
              childOrderProductsTableData={childOrderProductsTableData}
              showEnterPaymentModal={() => setCollectPaymentModal(true)}
            />
          )}

          {/* //& Care Session Details */}
          <CareSessionDetails
            bookingDetails={bookingDetails}
            openAppntNotesModal={openAppntNotesModal}
            openClinicalNotesModal={openClinicalNotesModal}
            sendSummaryReport={sendSummaryReport}
            cancelBooking={handleCancelBookingAction}
            markAsNoShow={handleMarkAsNoShowAction}
            rescheduleBooking={rescheduleBooking}
            completeClinicalService={completeClinicalService}
            enterPaymentInfo={enterPaymentInfo}
          />

          <LabOrderRequisition
            show={isQuestionnaireFormOpen}
            onHide={hideQuestionnaireForm}
            referenceDetails={bookingDetails}
            referenceLocation={"BOOKING"}
            patientDetails={patientData}
          />

          {/* //& Create Kit */}
          {isRestrictClinicalAccess === false && (
            <CreateKit
              clinicalRef={clinicalRef}
              bookingDetails={bookingDetails}
              showKitCreateModal={showKitCreateModal}
              setShowKitCreateModal={setShowKitCreateModal}
              orderKitForBookingFunc={orderKitForBookingFunc}
            />
          )}

          {/* //& Clinical Charting Logs */}
          {(isClinician || isSuperAdmin) && (
            <Accordion defaultExpanded className="mb-4 rounded-none" ref={historyRef}>
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel1a-content"
                id="panel1a-header"
                style={{ background: "#0000000F" }}
              >
                <Card.Header id="cardTitle" className=" w-100 border-0 bg-transparent ">
                  <Row id="cardTitle  w-100">
                    <Col>Clinical / Charting log</Col>
                  </Row>
                </Card.Header>
              </AccordionSummary>
              <AccordionDetails className="accordionDetails">
                <Container fluid className="text-left mb-2">
                  <Row>
                    <Col>
                      <div className="tabsContent px-4">
                        {chartNotes?.length > 0 &&
                          chartNotes.map((chartNote, index) => (
                            <SingleChart
                              search={""}
                              key={index}
                              chartStatus={chartNote?.status}
                              referenceId={chartNote?.referenceId}
                              isClinicalRequired={chartNote?.authorName ? false : true}
                              authorName={chartNote?.authorName}
                              createdDate={convertEpochToDate(chartNote?.createdEpoch)}
                              chartDetails={chartNote}
                              noteMessage={chartNote?.note}
                              patientDetail={patientData}
                              cb={getChartNotesByBookingId}
                            />
                          ))}
                      </div>
                    </Col>
                  </Row>
                </Container>
              </AccordionDetails>
            </Accordion>
          )}

          {/* //& Booking Logs */}
          <Accordion defaultExpanded className="mb-4 rounded-none">
            <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel1a-content" id="panel1a-header" style={{ background: "#0000000F" }}>
              <Card.Header id="cardTitle" className=" w-100 border-0 bg-transparent ">
                <Row id="cardTitle  w-100">
                  <Col>Manage booking logs / History</Col>
                </Row>
              </Card.Header>
            </AccordionSummary>
            <AccordionDetails className="accordionDetails">
              <Row className="TimelineRow">
                <HistoryComponent data={sortedHistoryLogs} />
              </Row>
            </AccordionDetails>
          </Accordion>
        </div>
        <SelectAndExecute
          actions={[
            {
              name: "Mark Booking Confirmed",
              onClick: openConfirmPendingBooking,
              isDisabled: isReadOnly,
              isHide: !bookingDetails?.bookingStatus?.includes("PENDING"),
            },
            { name: "Submit Appointment Notes", onClick: openAppntNotesModal, isDisabled: isReadOnly },
            { name: "Submit Clinician/Charting Notes", onClick: openClinicalNotesModal, isDisabled: isReadOnly || isRestrictClinicalAccess },
            { name: "Cancel Booking [pro active]", onClick: handleCancelBookingAction, isDisabled: isReadOnly },
            { name: "Mark as No Show", onClick: handleMarkAsNoShowAction, isDisabled: isReadOnly },
            { name: "Reschedule", onClick: rescheduleBooking, isDisabled: isReadOnly },
            { name: "Complete clinical service", onClick: completeClinicalService, isDisabled: isReadOnly || isRestrictClinicalAccess },
            { name: "Enter payment info", onClick: enterPaymentInfo, isDisabled: isReadOnly },
            { name: "Create Charting Notes", onClick: () => setShowChartingNotesModal(true), isDisabled: isReadOnly },
            {
              name: "Send Prescription",
              onClick: () => {
                handleSendPrescription(bookingDetails?.email);
              },
              isDisabled: isReadOnly,
            },
            { name: "Send visit summary to patient", onClick: sendSummaryReport, isDisabled: isReadOnly || isRestrictClinicalAccess },
            {
              name: "Lab order request",
              onClick: () => {
                setIsQuestionnaireFormOpen(!isQuestionnaireFormOpen);
              },
              isDisabled: isReadOnly || isRestrictClinicalAccess,
            },
            { name: "Schedule Follow-up Appointment", onClick: () => scheduleFollowUp(patientData, bookingDetails?.careStateRegion || 'NV'), isDisabled: isReadOnly },
          ]}
        />
      </div>

      {showConfirmPendingBookingModal && (
        <GenericConfirmationModal
          title={"Confirm Booking"}
          message={"Are you sure you want to update the booking status to confirmed?"}
          buttonText={"Confirm"}
          handleClose={() => setShowConfirmPendingBookingModal(false)}
          isShowReason={true}
          showModal={showConfirmPendingBookingModal}
          handleConfirm={handleConfirmPendingBooking}
        />
      )}

      {/* //& MODALS START HERE */}
      <ReleaseNotesModal
        isBookingSendPatientSummary={true}
        show={releaseNotesModalOpen}
        onHide={() => setReleaseNotesModalOpen(false)}
        details={bookingDetails}
        submitNotes={sendReportNow}
        // handleSnackOpen={handleSnackOpen}
        templates={templates}
      />

      <SendNotesModal
        subTitle={"* This note is for general booking managing purpose *. Use 'Submit clinician notes' for clinical charting."}
        title="Add Appointment Notes"
        show={showAppntNotesModal}
        onHide={() => setShowAppntNotesModal(false)}
        details={bookingDetails}
        submitNotes={submitNotesNow}
      />

      <SendNotesModal
        subTitle={"* This note is for charting *. Use 'Submit appointment notes' for general booking management."}
        title="Submit Clinical Notes"
        show={showClinicalNotesModal}
        onHide={() => setShowClinicalNotesModal(false)}
        details={bookingDetails}
        submitNotes={submitClinicalNotesNow}
      />

      <MarkNoShowModal
        subTitle={"Provide a reason for marking this booking as No Show"}
        title="Mark as no Show"
        show={showMarkNoShowModal}
        onHide={() => setShowMarkNoShowModal(false)}
        details={bookingDetails}
        submit={handleNoShowModalSubmit}
      />

      <MarkNoShowModal
        subTitle={"Provide a reason for marking this booking as Cancelled"}
        title="Cancel Booking"
        show={showCancelBookingModal}
        onHide={() => setShowCancelBookingModal(false)}
        details={bookingDetails}
        submit={handleCancelBookingModalSubmit}
      />

      {/* //$ Update Patient Info Modal */}
      <PatientInfoModal
        showPatientInfoUpdateConfirmModal={showPatientInfoUpdateConfirmModal}
        handleClose={handleClose}
        setPatientInfoUpdateReason={setPatientInfoUpdateReason}
        updatePatientInfo={updatePatientInfo}
      />
    
          {/* Disabled due to security configs for document access. Re-enable when secure/presigned doc flow is available. */}
          {/*
          <PatientIdentityDocsModal
        show={showIdentityDocsModal}
        setShow={openIdentityDocsModal}
        handleClose={handleClose}
        rejectDoc={rejectDoc}
        acceptDoc={acceptDoc}
        changeCompletePaymentData={changeCompletePaymentData}
        completePayment={completeAppointment}
        isSelfCheckInIdentityVerified={bookingDetails?.isSelfCheckInIdentityVerified}
        govermentIssuedId={bookingDetails?.documentS3UrlMap?.IDENTITY_PASSPORT || bookingDetails?.documentS3UrlMap?.IDENTITY_DRIVER_LICENSE}
        selfie={bookingDetails?.documentS3UrlMap?.SELFIE}
        bookingId={bookingId ?? bookingDetails?.id ?? null}
        refreshBookingDetails={intialLoadingFetchAndSetBookingDetails}
      />
          */}

      {/* Disabled due to security configs for document access. Re-enable when secure/presigned doc flow is available. */}
      {/*
      <VerifyDocsModal
        show={verifyDocsModal}
        handleClose={handleClose}
        rejectDoc={rejectDoc}
        acceptDoc={acceptDoc}
        changeCompletePaymentData={changeCompletePaymentData}
        completePayment={completeAppointment}
        isSelfCheckInIdentityVerified={bookingDetails?.isSelfCheckInIdentityVerified}
        govermentIssuedId={bookingDetails?.documentS3UrlMap?.IDENTITY_PASSPORT || bookingDetails?.documentS3UrlMap?.IDENTITY_DRIVER_LICENSE}
        selfie={bookingDetails?.documentS3UrlMap?.SELFIE}
      />
      */}
      {/* //$ send signup link */}
      <SendSignupLinkModal signupModal={signupModal} handleClose={handleClose} sendSignupLink={sendSignupLink} />

      {/* //$ send payment link modal */}
      <SendPaymentLinkModal payModal={payModal} handleClose={handleClose} sendPayLink={sendPayLink} />

      {/* //$ Complete Booking Modal */}
      <CompleteBookingModal
        completeBookingModal={completeBookingModal}
        handleClose={handleClose}
        changeBookingData={changeBookingData}
        completeAppointment={completeClinicalAppointment}
      />

      {/* //$ Complete Payment Modal */}
      <CompletePaymentModal
        orderPaySummary={orderSummary}
        completeBookingAndCollectPaymentModal={completeBookingAndCollectPaymentModal}
        handleClose={handleClose}
        changeCompletePaymentData={changeCompletePaymentData}
        completePayment={completeAppointment}
      />

      {/* Disabled due to security configs for document access. Re-enable when secure/presigned doc flow is available. */}
      {/*
      <Worker workerUrl="https://unpkg.com/pdfjs-dist@2.5.207/build/pdf.worker.min.js"></Worker>
      <VerifyDocsModal
        show={verifyDocsModal}
        handleClose={handleClose}
        rejectDoc={rejectDoc}
        acceptDoc={acceptDoc}
        changeCompletePaymentData={changeCompletePaymentData}
        completePayment={completeAppointment}
        isSelfCheckInIdentityVerified={bookingDetails?.isSelfCheckInIdentityVerified}
        govermentIssuedId={bookingDetails?.documentS3UrlMap?.IDENTITY_PASSPORT || bookingDetails?.documentS3UrlMap?.IDENTITY_DRIVER_LICENSE}
        selfie={bookingDetails?.documentS3UrlMap?.SELFIE}
      />
      */}
      {showErxModal && <ERXModal eRxid={eRxId} onHide={hideErxModal} />}
      {/* //$ Calcom Inline Integration */}
      <CalcomModal show={calModal} close={handleClose} data={bookingDetails} />
    </Container>
  );
};

export default BookingDetails;
